import { CaseTypes } from "us.common/constants";
import dayjs from "dayjs";
import { FilterValues } from "../Types";
import { CaseSearchResult } from "reducers/GlobalSearch/Types";

/**
 * @function
 * @description Determine if the case should be included based on the filter criterias
 * @returns the boolean decision if the case should be included
 */
export const doesCaseInclude = (
  {
    caseType,
    mainAmount,
    balance,
    debtorName,
    creditorName,
    debtorNo,
    creditorNo,
    exCaseNo,
    birthDate,
    phone,
    address,
    invoiceNumber,
    lastMessageActivityName,
    additionalReference1,
    additionalReference2
  }: CaseSearchResult,
  {
    isOpenCase,
    isCloseCase,
    isNextDueDateCase,
    isSentenceCase,
    isCourtCase,
    caseNumber,
    invoiceNumber: invoiceNo,
    mainAmount: filterMainAmont,
    balance: filterBalance,
    debtorNameNo,
    creditorNameNo,
    birthdate: filterBirthdate,
    phone: filterPhone,
    address: filterAddress,
    lastMsgActivityName,
    additionalReference1: filterAdditionalReference1,
    additionalReference2: filterAdditionalReference2
  }: FilterValues
): boolean => {
  try {
    return (
      ((isOpenCase && caseType === CaseTypes.OPEN) ||
        (isCloseCase && caseType === CaseTypes.CLOSED) ||
        (isNextDueDateCase && caseType === CaseTypes.MANUAL) ||
        (isSentenceCase && caseType === CaseTypes.SENTENCE_RECEIVED) ||
        (isCourtCase && caseType === CaseTypes.SENT_TO_COURT) ||
        ![
          CaseTypes.OPEN,
          CaseTypes.CLOSED,
          CaseTypes.MANUAL,
          CaseTypes.SENTENCE_RECEIVED,
          CaseTypes.SENT_TO_COURT,
        ].includes(caseType)) &&
      (invoiceNo ? invoiceNumber.toString().includes(invoiceNo) : true) &&
      (caseNumber ? exCaseNo.toString().includes(caseNumber) : true) &&
      (filterMainAmont
        ? mainAmount.toString().includes(filterMainAmont)
        : true) &&
      (filterBalance ? balance.toString().includes(filterBalance) : true) &&
      (debtorNameNo
        ? debtorName.toUpperCase().includes(debtorNameNo.toUpperCase()) ||
        debtorNo === debtorNameNo
        : true) &&
      (creditorNameNo
        ? creditorName.toUpperCase().includes(creditorNameNo.toUpperCase()) ||
        creditorNo.toString() === creditorNameNo
        : true) &&
      (filterBirthdate
        ? dayjs(birthDate).isSame(dayjs(filterBirthdate))
        : true) &&
      (filterPhone ? phone === filterPhone : true) &&
      (filterAddress
        ? address
          .replaceAll(/\s+/g, " ")
          .toUpperCase()
          .includes(filterAddress.replaceAll(/\s+/g, " ").toUpperCase())
        : true) &&
      (lastMsgActivityName
        ? lastMessageActivityName
          .toUpperCase()
          .includes(lastMsgActivityName.toUpperCase())
        : true) &&
      (filterAdditionalReference1
        ? additionalReference1.toString() === filterAdditionalReference1.toString()
        : true) &&
      (filterAdditionalReference2
        ? additionalReference2.toString() === filterAdditionalReference2.toString()
        : true)
    );
  } catch (e) {
    return false;
  }
};
